import axios from 'axios'

// demo
// export const PatientConfig = axios.create({
//   baseURL: 'https://demo-api.mymindmitra.com/',
// })
// export const socketUrl = 'wss://demo-api.mymindmitra.com'
// end of demo

// localhost
// export const PatientConfig = axios.create({
//     baseURL: "http://127.0.0.1:8005/", //Akbar's
// //     // baseURL: "http://192.168.1.155:8000/", //Ruby's
// });
// export const socketUrl = "ws://127.0.0.1:8005"; //Akbar's
// export const socketUrl = "ws://192.168.1.155:8000"; //Ruby's
// end of localhost

// live
export const PatientConfig = axios.create({
    baseURL: "https://api.mymindmitra.com/",
});
export const socketUrl = "wss://api.mymindmitra.com";
// end of live


// Add request interceptor to include access token
PatientConfig.interceptors.request.use(
  (config) => {
    const userDetails = localStorage.getItem("user_details");
    if (userDetails) {
      try {
        const user = JSON.parse(userDetails);
        if (user.access_token) {
          config.headers.Authorization = `Bearer ${user.access_token}`;
        }
      } catch (error) {
        console.error("Error parsing user details:", error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

